import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

export const getHomeSectionsService = async (pageKey = "home") => {
  const query = new URLSearchParams({page_key: pageKey}).toString();
  return publicRequest.get(`${ConfEnv.API_HOME_SECTIONS.URL}?${query}`);
};
